module.exports = __webpack_public_path__ + "img/title.92a081e3.png";